// Columns shown in the IDU table.
// controllable:true → cell is clickable and opens the command modal.

import moment from "moment";

// format: optional display formatter; defaults to POINT_LABELS lookup.
export const IDU_COLUMNS = [
  { key: 'floorName', header: 'Floor', controllable: false, format: v => v || "N/A" },
  { key: 'Status', header: 'Status', controllable: true },
  { key: 'Mode', header: 'Mode', controllable: true },
  { key: 'SetTemperature', header: 'Set Temp', controllable: true, format: v => v != null ? `${v}°C` : '–' },
  { key: 'CurrentTemperature', header: 'Current Temp', controllable: false, format: v => v != null ? `${v}°C` : '–' },
  { key: 'FanSpeed', header: 'Fan Speed', controllable: true },
  { key: 'AirflowDir', header: 'Air Flow Direction', controllable: true },
  { key: 'LastUpdatedTime', header: 'Updated Time', controllable: false, format: v => v != null ? moment.unix(v).format("DD MMM YYYY, h:mm A") : '–' },
];

export const POINT_LABELS = {
  Status: { 0: 'OFF', 1: 'ON' },
  Mode: { 1: 'COOL', 2: 'HEAT', 3: 'AUTO', 4: 'DRY', 5: 'FAN' },
  FanSpeed: { 1: 'LOW', 2: 'MED', 3: 'HIGH', 4: 'TOP', 5: 'AUTO' },
  AirflowDir: { 1: 'HORIZONTAL', 2: '30°', 3: '60°', 4: 'VERTICAL', 5: 'SWING' },
};

export const POINT_OPTIONS = {
  Status: [
    { value: 0, label: 'OFF' },
    { value: 1, label: 'ON' },
  ],
  Mode: [
    { value: 1, label: 'COOL' },
    { value: 4, label: 'DRY' },
    { value: 5, label: 'FAN' },
  ],
  FanSpeed: [
    { value: 1, label: 'LOW' },
    { value: 2, label: 'MED' },
    { value: 3, label: 'HIGH' },
    // { value: 4, label: 'TOP' },
    // { value: 5, label: 'AUTO' },
  ],
  AirflowDir: [
    { value: 1, label: 'HORIZONTAL' },
    { value: 2, label: '30°' },
    { value: 3, label: '60°' },
    { value: 4, label: 'VERTICAL' },
    { value: 5, label: 'SWING' },
  ],
};

export const MAX_ATTEMPTS = {
    Status: 10,
    SetTemperature: 5,
    Mode: 3,
    FanSpeed: 3,
    AirflowDir: 3,
  }